export default __webpack_public_path__ + "static/media/ru.35afa4a4.svg";